import { config, handleResponse } from '../../_helpers';

export const chargeServiceMatrixService = {
    getAllChargeServiceMatrix,
    getChargeServiceMatrixById,
    updateChargeServiceMatrix,
    createChargeServiceMatrix,
    searchChargeServiceMatrix,
    deleteChargeServiceMatrix,
    activation,
    getFullServicesMatrix
};

function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/ChargeServicesMatrices/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}

function getAllChargeServiceMatrix(skip, take) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ChargeServicesMatrices/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
}

function getChargeServiceMatrixById(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ChargeServicesMatrices/get/${id}`, requestOptions).then(handleResponse);
}

function updateChargeServiceMatrix(charge,profile) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify({
            chargeCode: charge.chargeCode,
            serviceModeCode: charge.serviceModeCode,
            chargeClass: charge.chargeClass,
            isActive: charge.isActive,
            userModified: profile.userId
            
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ChargeServicesMatrices/update/${charge.id}`, requestOptions).then(handleResponse);
}

function createChargeServiceMatrix(Charge) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(Charge),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ChargeServicesMatrices`, requestOptions).then(handleResponse);
}


function deleteChargeServiceMatrix(id, chargeCode) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/ChargeServicesMatrices/delete/${chargeCode}`, requestOptions).then(handleResponse);
}

function searchChargeServiceMatrix(skip, take, search, filter) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ChargeServicesMatrices/load?skip=${skip}&take=${take}&search=${search}&filter=${filter}`, requestOptions).then(handleResponse);
}

function getFullServicesMatrix() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ChargeServicesMatrices`, requestOptions).then(handleResponse);
}